module.exports = __webpack_public_path__ + "img/btn_menu_jyz.6009f685.png";